<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        name: 'App',
        components: {
        },
        created() {
          //   this.retrieveErgoRiskMatrixByUser(this)
          // if (this.$store.state.userInfo.id) {
          // }
          this.$store.watch((state) => { return [state.userToQuery, state.sequenceFilter,
                                                 state.filterPage, state.filterSortType] },
                            () => { this.retrieveErgoRiskMatrixByUser(this)} )
        },
        methods: {
          ...mapActions(["retrieveErgoRiskMatrixByUser"]),
        }
    }
</script>

<style>
    body {
        margin: 0px;
        padding: 0px;
    }

    #app {
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
        /*-webkit-font-smoothing: antialiased;*/
        /*-moz-osx-font-smoothing: grayscale;*/
        /*!*text-align: center;*!*/
        /*color: #2c3e50;*/
        /*!*margin-top: 60px;*!*/
    }
</style>

<style lang="less">
/*@import '~vux/src/styles/reset.less';*/
</style>
